let patternSocket = {};

patternSocket.socketInstance = null;
patternSocket.socketInstanceList = [];

export {patternSocket}